















import {bus} from '@/main'
import {Component, Prop, Vue} from 'vue-property-decorator'

@Component({})
export default class WidgetFrame extends Vue {
  @Prop(String) public title?: string
  @Prop(String) public downloadUrl?: string

  private config = false

  public created() {
    bus.$on('dashboard-config', (config: boolean) => {
      this.config = config
    })
  }

  public download() {
    window.open(this.downloadUrl, "_blank")
  }
}
